import styled from 'styled-components';

export const ContactUsSection = styled.section`
  width: 100%;
  padding: var(--space-xxxxl) var(--space-xxxl);
  background: linear-gradient(180deg, var(--white) 0%, var(--offWhite) 100%);

  @media screen and (max-width: 950px) {
    padding: var(--space-xxxl) var(--space-xl);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) var(--space-m);
  }
`;

export const ContactGrid = styled.div`
  width: min(100%, 1380px);

  margin: 0 auto;

  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: var(--space-xxxl);

  align-items: start;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-xxl);
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-xl);
  }
`;

export const ContactInfoLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h2 {
    margin: var(--space-xs) 0 var(--space-m) 0;

    color: var(--grey7);

    font-size: clamp(2.2rem, 4vw, 3.6rem);
    line-height: 1;
    font-weight: 900;

    letter-spacing: -0.04em;
  }

  .contactIntro {
    max-width: 680px;

    margin: 0 0 var(--space-xl) 0;

    color: var(--grey5);

    font-size: 1rem;
    line-height: 1.8;
    font-weight: 500;
  }
`;

export const ContactDetailRow = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  padding: var(--space-l) 0;

  border-top: 1px solid rgba(15, 23, 42, 0.08);

  svg {
    margin-top: 0.15rem;

    color: var(--orange5);

    font-size: 1.15rem;

    flex-shrink: 0;
  }

  strong {
    display: block;

    margin-bottom: var(--space-xxs);

    color: var(--grey7);

    font-size: 0.9rem;
    font-weight: 850;

    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  p,
  address {
    margin: 0;

    color: var(--grey4);

    font-size: 0.95rem;
    line-height: 1.65;
    font-weight: 500;
    font-style: normal;
  }
`;

export const ContactUsContainer = styled.div`
  padding: var(--space-xl);

  background: var(--white);

  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 24px;

  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);

  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  h3 {
    margin: 0 0 var(--space-xs) 0;

    color: var(--grey7);

    font-size: 1.25rem;
    line-height: 1.3;
    font-weight: 850;
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
    border-radius: 18px;
  }
`;

export const StaffCard = styled.div`
  padding: var(--space-l);

  background: linear-gradient(
    180deg,
    rgba(249, 250, 251, 0.96) 0%,
    rgba(255, 255, 255, 1) 100%
  );

  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 18px;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);

  h4 {
    margin: 0 0 var(--space-xxs) 0;

    color: var(--grey7);

    font-size: 1.05rem;
    font-weight: 850;
    line-height: 1.3;
  }

  p {
    margin: 0;

    color: var(--orange5);

    font-size: 0.82rem;
    font-weight: 850;

    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
`;

export const StaffLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  a {
    display: inline-flex;
    align-items: center;
    gap: var(--space-xs);

    color: var(--grey5);

    text-decoration: none;

    font-size: 0.92rem;
    font-weight: 650;

    transition:
      color 0.2s ease,
      transform 0.2s ease;

    svg {
      color: var(--orange5);
      font-size: 0.95rem;
      flex-shrink: 0;
    }

    &:hover {
      color: var(--orange5);
      transform: translateX(2px);
    }
  }
`;
